import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { PhoneIcon } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useSite } from "../context/SiteContext";
import { locations } from "../data/locations";
export function MobileActionBar() {
  const {
    selectedLocation,
    t
  } = useSite();
  const {
    pathname
  } = useLocation();
  const reduceMotion = useReducedMotion();
  const routeLocation = pathname.includes("victor") ? "victor" : pathname.includes("driggs") ? "driggs" : selectedLocation;
  const location = locations[routeLocation];
  return <motion.nav initial={reduceMotion ? undefined : {
    y: 88
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1],
    delay: 0.5
  }} className="fixed inset-x-0 bottom-0 z-50 flex items-center gap-2 border-t border-agavedeep/10 bg-cream/95 px-3 pb-[max(10px,env(safe-area-inset-bottom))] pt-2.5 shadow-[0_-8px_30px_rgba(15,59,46,.12)] backdrop-blur md:hidden" aria-label={t("Quick actions", "Acciones rápidas")} data-id="element-363" data-mp="3s8zc450r7jr6">
      <a href={location.phoneHref} aria-label={`${t("Call", "Llamar")} ${location.officialName}`} className="inline-flex h-12 w-12 flex-none items-center justify-center rounded-full border border-agavedeep/20 text-agavedeep" data-id="element-364" data-mp="1elp2j2cm7pjo">
        <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-365" data-mp="10ro9mp8cgwr8" />
      </a>
      <Link to="/locations" className="inline-flex min-h-12 flex-1 items-center justify-center whitespace-nowrap rounded-full bg-marigold text-sm font-bold text-agavedeep transition-transform duration-150 active:scale-[0.97]" data-id="element-366" data-mp="vtw7z3hwdw9u">
        {t("Visit Us", "Visítanos")}
      </Link>
      <Link to="/catering" className="inline-flex min-h-12 flex-1 items-center justify-center whitespace-nowrap rounded-full bg-agavedeep text-sm font-bold text-cream transition-transform duration-150 active:scale-[0.97]" data-id="element-367" data-mp="hu507khz5c4a">
        {t("Plan Your Event", "Planea tu evento")}
      </Link>
    </motion.nav>;
}